import { environment } from '@env/environment';
import * as moment from 'moment';
import { NullableDate } from './models/nullable';
export class DateUtilities {
  public static getLastDayOfMonth(year: number, month: number) {
    return new Date(year, month + 1, 0);
  }

  public static getDateArray(date: Date): number[] {
    const mDate: moment.Moment = moment(date);
    return [mDate.year(), mDate.month() + 1, mDate.date()];
  }

  public static toExpectedFormat(date: string | Date, expectedFormat: string): string {
    return moment(new Date(date)).format(expectedFormat);
  }

  public static toExpectedTimezone(date: string | Date | NullableDate): Date {
    if (date === null) {
      date = new Date(1700, 1, 1);
    }
    return moment.utc(new Date(date)).tz(environment.languageTimezone).toDate();
  }

  public static toExpectedTimezoneFormat(date: string | Date | NullableDate, expectedFormat: string): string {
    if (date === null) {
      date = new Date(1700, 1, 1);
    }
    return moment.tz(date, environment.languageTimezone).format(expectedFormat);
  }
}
